import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  DurationSchemaWithMax,
  DurationUnits,
  RunMode,
} from '../base/baseSchema.js';

const HL7V2_STORE_BASE_PATH = `projects/notable-core-prod/locations/us-central1/datasets/`;
const PROD_DATASET = 'prod-health/hl7V2Stores/';
const TEST_DATASET = 'test-health/hl7V2Stores/';

export enum DatastoreInstanceType {
  NON_PRODUCTION = 'NON_PRODUCTION',
  PRODUCTION = 'PRODUCTION',
}

/**
 * @deprecated This will be replaced with customer agnostic routing.
 * PRD: https://docs.google.com/document/d/10Ed0G7v-Nfb4Ach-OR5LspA1dgHAMT_aRY1Iaj8oQ68/edit?tab=t.0#heading=h.cd65rewounfq
 * Ticket: https://app.asana.com/0/1209009995423076/1209094266853167
 * message destinations will no longer be hardcoded like below and instead will be pulled from config stored in the database
 */
export const DEPRECATED_HARD_CODED_ORGANIZATION_IDS_TO_DATA_STORE_PATHS: {
  [orgId: string]: { [key in DatastoreInstanceType]: string } | undefined;
} = {
  // BAPTIST_HEALTH
  '95e22c3b-8447-4450-b551-54419acd3623': {
    [DatastoreInstanceType.NON_PRODUCTION]: `${HL7V2_STORE_BASE_PATH}${TEST_DATASET}test-health-baptist-hl7`,
    [DatastoreInstanceType.PRODUCTION]: `${HL7V2_STORE_BASE_PATH}${PROD_DATASET}prod-health-baptist-hl7`,
  },
  // COMMUNITY_HEALTH_NETWORK
  '38b6db06-0c01-40a0-b3ea-f105f5d52b9c': {
    [DatastoreInstanceType.NON_PRODUCTION]: `${HL7V2_STORE_BASE_PATH}${TEST_DATASET}test-health-chn-hl7`,
    [DatastoreInstanceType.PRODUCTION]: `${HL7V2_STORE_BASE_PATH}${PROD_DATASET}prod-health-chn-hl7`,
  },
  // MUSC
  '3146707b-b97f-4dc8-a784-d3ee48c6149a': {
    [DatastoreInstanceType.NON_PRODUCTION]: `${HL7V2_STORE_BASE_PATH}${TEST_DATASET}test-health-musc-hl7`,
    [DatastoreInstanceType.PRODUCTION]: `${HL7V2_STORE_BASE_PATH}${PROD_DATASET}prod-health-musc-hl7`,
  },
  // NKCH
  'dd9dbde1-b8eb-4d3b-8a2e-e9e57fc78d9c': {
    [DatastoreInstanceType.NON_PRODUCTION]: `${HL7V2_STORE_BASE_PATH}${TEST_DATASET}test-health-nkch-hl7`,
    [DatastoreInstanceType.PRODUCTION]: `${HL7V2_STORE_BASE_PATH}${PROD_DATASET}prod-health-nkch-hl7`,
  },
};

export const Hl7BlockConfigSchema = z.object({
  message: z.string(),
  destinationDatastore: z.string(),
  runMode: z.nativeEnum(RunMode).optional().default(RunMode.Live),
  timeout: DurationSchemaWithMax('timeout', {
    value: 3,
    units: DurationUnits.Minutes,
  }),
});

export type Hl7BlockConfig = z.infer<typeof Hl7BlockConfigSchema>;

export const Hl7BlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.Hl7),
  config: Hl7BlockConfigSchema,
});

export type Hl7Block = z.infer<typeof Hl7BlockSchema>;
